import { AUDIO, VIDEO } from './constants';
import isTypeStatic from './isTypeStatic';
import stripBitrates from './stripBitrates';
import serializeDocument from './serializeDocument';
import { Bitrates, Playback } from '../../config/interfaces';
import coerceBitrates from '../../bitrates/coerceBitrates';
import { isPositive } from '../utils/numbers';

function getBitrates(document: Document, playback: Playback): Bitrates {
  const isVOD = isTypeStatic(document);
  const bitrates = isVOD ? playback.vod || {} : playback.live || {};
  return coerceBitrates(bitrates);
}

/**
 * See [MPEG-DASH XSD](https://standards.iso.org/ittf/PubliclyAvailableStandards/MPEG-DASH_schema_files/DASH-MPD.xsd).
 * This function strips bitrates that do not fall between min and max for both audio and video when configured in playback.
 * If no bitrates are found, the smallest bitrate will be returned.
 * @param manifestText - manifest to parse
 * @param playback - playback config.
 */
export default function(manifestText: string, playback: Playback): string {
  try {
    // create a dom parser
    const domParser = new DOMParser();
    const document = domParser.parseFromString(manifestText, 'text/xml');
    const {
      minVideoBitrate,
      maxVideoBitrate,
      minAudioBitrate,
      maxAudioBitrate
    } = getBitrates(document, playback);
    // video
    let modified = false;
    let stripped = document;
    if (isPositive(minVideoBitrate) || isPositive(maxVideoBitrate)) {
      modified = true;
      stripped = stripBitrates(
        stripped,
        VIDEO,
        minVideoBitrate as number,
        maxVideoBitrate as number
      );
    }
    if (isPositive(minAudioBitrate) || isPositive(maxAudioBitrate)) {
      modified = true;
      stripped = stripBitrates(
        stripped,
        AUDIO,
        minAudioBitrate as number,
        maxAudioBitrate as number
      );
    }

    return modified ? serializeDocument(stripped) : manifestText;
  } catch (e) {
    return manifestText;
  }
}
